import React, { KeyboardEventHandler } from 'react';
import { FormField } from '../FormField';
import { FormNumberInput } from './FormNumberInput';

export const FormNumberField: React.FC<Props> = (props) => {
    return <FormField label={props.label} error={props.error}>
        <FormNumberInput
            hasError={!!props.error}
            {...props}
        />
    </FormField>;
};

interface Props {
    label?: string;
    error?: string|null;
    value?: string;
    onChangeText?: ((text: string) => void);
    onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
}
